module.exports = __webpack_public_path__ + "img/canaanorte-white.c85b48a1.png";